import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../core/services/data.service';
import { IArticle } from '../../core/models/IArticle.type';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { AuthenticationService } from '../../core/services/authentication.service';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { AngularEditorConfig } from '@kolkov/angular-editor';


interface Category {
  value: string;
  viewValue: string;
}

interface Environment {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit {
  htmlContent: string;
  htmlTitle: string;
  htmlTags: string [] = [];
  articleId: number;
  showEditor: boolean;
  selectedRowIndex: number;
  showListArticles: boolean;
  idArticle: number;
  categories: Category[] = [
    {value: 'angular', viewValue: 'angular'}, 
    {value: 'html5', viewValue: 'html5'}
  ];
  selectedEnvironment: string;
  //category: string;
  selectedCategory: string;

  articles:IArticle[];
  displayedColumns: string[] = ['id', 'title', 'article_id', 'image', 'environment', 'category', 'tags', 'creationDate', 'updateDate'];
  dataSource = new MatTableDataSource<IArticle>();
  selection = new SelectionModel<IArticle>(true, []);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  subSink = new SubSink();

  constructor(private router: Router, private authService: AuthenticationService, private dataServices:DataService) { 
    this.showEditor = false;
    this.showListArticles = true;
  }

  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
  }


  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      []
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  ngOnInit(): void {
    this.subSink.add(this.authService.isLoggedIn().subscribe(data => {
      if(data)
        this.getListArticles();
      else
        this.router.navigate(['login-page']);
    }))
  }

  changeEnv(ev) {
    this.selectedEnvironment = ev;

    if(ev == 'back-end')
      this.categories = [
        {value: 'nodejs', viewValue: 'nodejs'}, 
        {value: 'c#', viewValue: 'c#'}
      ]
    else
      this.categories = [
        {value: 'angular', viewValue: 'angular'}, 
        {value: 'html5', viewValue: 'html5'}
      ]
  }

  changeCategory(ev) {
    this.selectedCategory = ev;
  }

  getListArticles(){
    this.subSink.add(this.dataServices.getArticles().subscribe(data=>{
        if(data){
          this.articles = data.result;
          this.dataSource.data = data.result;
        }
      })
    );
  }

  goBack(){
    this.showListArticles = true;
    this.showEditor = false;
    this.getListArticles();
  }

  addArticle(row){
    
    if(this.selectedRowIndex == row.id){
      this.hideEditor();
    }
    else{
      this.showEditor = true;
      this.selectedRowIndex = row.id;
      this.htmlTitle = row.title;
      this.htmlTags = row.tags;
      this.selectedEnvironment = row.environment;
      this.selectedCategory = row.category;
      this.dataServices.getArticle(row.article_id).subscribe(data=>{
        console.log("Article", data.result)
        this.articleId = data.result[0].id;
        this.htmlContent = data.result[0].article;
      });
      //console.log("this.environment", this.environment)
      this.getListArticles();
    }
  }

  hideEditor(){
    this.selectedRowIndex = null;
    this.htmlTitle = '';
    this.htmlContent = '';
    this.showEditor = false;
  }

  newArticle(){
    this.showListArticles = false;
    this.htmlTitle = '';
    this.htmlContent = '';
    this.htmlTags = [];
    this.selectedEnvironment = '';
    this.selectedCategory = '';
    this.showEditor = true;
  }

  postArticle(){
    this.dataServices.postArticle(this.htmlTitle, this.htmlContent, this.htmlTags, this.selectedEnvironment, this.selectedCategory).subscribe(data=>{ //this.environment, this.category
      console.log("DATA POST", data);
      if(data.status == 200){
        window.location.reload();
      }
    });
  }

  updateArticle(){
    this.dataServices.putArticle(this.selectedRowIndex, this.htmlTitle, this.htmlContent, this.articleId, this.selectedEnvironment, this.selectedCategory).subscribe(data=>{
      console.log("DATA POST", data);
      if(data.status == 200){
        window.location.reload();
      }
    });
  }

  deleteArticle(){
    this.dataServices.deleteArticle(this.selectedRowIndex).subscribe(data=>{
      this.getListArticles();
      this.hideEditor();
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
